import axios from 'axios';
import config from './common';
import {logToSlack} from '../utils/logs/slack';
const instance = axios.create({
  baseURL: (process.env.NODE_ENV === 'production') ? config.api.base : 'http://localhost:8000',
  headers: {
    common: {
      'Access-Control-Allow-Headers': 'access-control-allow-origin,token',
      'Access-Control-Allow-Methods': 'GET,HEAD,PUT,PATCH,POST,DELETE',
      'Access-Control-Allow-Origin': '*'
    },
    post: {
      'Content-Type': 'application/json'
    },
    put: {
      'Content-Type': 'application/json'
    },
  },
});

export const setTokenHeader = token => {
  instance.defaults.headers.common['token'] = token;
};

export const setRequestIdHeader = guid => {
  instance.defaults.headers.common['transactionID'] = guid;
};

instance.interceptors.response.use(
  async response => {
    if (isUnauthorizedError(response)) {
      window.location.href = config.client.href;
    }
    if (isServerError(response)) {
      const callData = getDataFromResponse(response);
      await logToSlack(callData);

      return Promise.reject('Server returned error');
    }

    return response;
  },
  async error => {
    if (isUnauthorizedError(error.response)) {
      window.location.href = config.client.href;

      return Promise.reject('Unauthorized!');
    }
    if (isServerError(error.response)) {
      const callData = getDataFromResponse(error.response);
      await logToSlack(callData);

      return Promise.reject('Server returned error');
    }

    return Promise.reject(error);
  });

export default instance;

const isUnauthorizedError = response => response.status >= 400 && response.status < 500;
const isNotUnauthorizedError = response => response.status < 400 || response.status >= 500;
const isLogicalServerError = response => response.data.errorCode < 0 && isNotUnauthorizedError(response);
const isInternalServerError = response => response.status >= 500;
const isServerError = response => isInternalServerError(response) || isLogicalServerError(response);

const getDataFromRequest = request => {
  const {headers, params, method, baseURL, data, url} = request;

  return {
    headers,
    params,
    method,
    baseURL,
    url,
    data
  }
};

const getDataFromResponse = response => {
  const {
    config,
    status,
    statusText,
    data,
    headers,
  } = response;
  const request = getDataFromRequest(config);

  return {
    request,
    response: {
      status,
      statusText,
      data,
      headers,
    }
  };
};
